import { Spinner } from '@frontend/components/common';
import { LuCheck } from 'react-icons/lu';

const outlineClass = 'outline-background-default';

export interface SlotLayoutCellProps {
    slotNumber: string;
    isSelected: boolean;
    isDisabled: boolean;
    hasContent: boolean;
    isLoading?: boolean;
    onSelect?: () => void;
}

export const SlotLayoutCell = (props: SlotLayoutCellProps) => {
    const { slotNumber, isSelected, isDisabled, hasContent, isLoading, onSelect } = props;
    const isSelectable = !isDisabled && !isLoading && onSelect != null;

    if (isDisabled) {
        return (
            <div className={`bg-brand-disabled ${outlineClass} flex size-full items-end p-1`}>
                {slotNumber ? <div className='text-background-surface justify-start text-sm font-semibold'>{slotNumber}</div> : null}
            </div>
        );
    }

    if (isLoading) {
        return (
            <div className={`bg-brand-secondary ${outlineClass} relative flex size-full items-end p-1`}>
                <div className='text-background-surface justify-start text-sm font-semibold'>{slotNumber}</div>
                <div className='pointer-events-none absolute inset-0 flex items-center justify-center'>
                    <Spinner className='text-border-default fill-brand-primary size-6' />
                </div>
            </div>
        );
    }

    if (isSelected) {
        return (
            <div
                role='button'
                tabIndex={0}
                className={`bg-status-success ${outlineClass} relative flex size-full cursor-pointer items-end p-1`}
                onClick={onSelect}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        onSelect?.();
                    }
                }}>
                <div className='text-background-surface justify-start text-sm font-semibold'>{slotNumber}</div>
                <div className='pointer-events-none absolute inset-0 flex items-center justify-center'>
                    <div className='bg-background-surface flex size-6 items-center justify-center rounded-full p-1'>
                        <LuCheck className='text-status-success size-5' />
                    </div>
                </div>
            </div>
        );
    }

    const bgClass = hasContent ? 'bg-brand-secondary' : 'bg-brand-muted';
    const content = <div className='text-background-surface justify-start text-sm font-semibold'>{slotNumber}</div>;

    if (isSelectable) {
        return (
            <div
                role='button'
                tabIndex={0}
                onClick={onSelect}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        onSelect?.();
                    }
                }}
                className={`${bgClass} ${outlineClass} flex size-full cursor-pointer items-end p-1`}>
                {content}
            </div>
        );
    }

    return <div className={`${bgClass} ${outlineClass} flex size-full items-end p-1`}>{content}</div>;
};
